export default {
  version: "le8g-3zv0",
};
